module.exports = __webpack_public_path__ + "static/media/mail-sent.d4c462a1.svg";